export const degresToRad = (degrees: number) => degrees * (Math.PI / 180);
